import { Modal } from './components/modal';

document.addEventListener('DOMContentLoaded', () => {
    const modalSelector = '#modal_download_catalog';
    const modal = document.querySelector(modalSelector);
    if (!modal) return;

    // Кешируем элементы один раз
    const elements = {
        openBtn: document.querySelector(`[data-modal="${modalSelector}"]`),
        closeBtn: modal.querySelector('.modal-close-m'),
        form: modal.querySelector('form'),
        head: modal.querySelector('.modal-head'),
        body: modal.querySelector('.modal-body')
    };

    const toggleModal = (show) => {
        modal.classList.toggle('tw-hidden', !show);
    };

    // ====== Открытие ======
    elements.openBtn?.addEventListener('click', e => {
        e.preventDefault();
        toggleModal(true);
    });

    // ====== Закрытие ======
    elements.closeBtn?.addEventListener('click', e => {
        e.preventDefault();
        toggleModal(false);
    });

    // Делегирование: один обработчик вместо двух
    modal.addEventListener('click', e => {
        if (e.target.closest('[data-inner="close"]') || e.target === modal) {
            e.preventDefault();
            toggleModal(false);
        }
    });

    // Закрытие по Esc
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !modal.classList.contains('tw-hidden')) {
            toggleModal(false);
        }
    });

    // ====== Обработка формы ======
    elements.form?.addEventListener('submit', async (e) => {
        e.preventDefault();

        const formData = new FormData(elements.form);

        try {
            const response = await fetch('/include/ajax/forms.php', {
                method: 'POST',
                body: formData
            });

            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const data = await response.json();

            if (data.type === 'true') {
                elements.head?.remove();
                elements.body.style.textAlign = 'center';
                elements.body.style.width = '60%';
                elements.body.innerHTML = 'Мы получили ваш запрос. В ближайшее время с вами свяжется менеджер и отправит каталог.';

                setTimeout(() => location.reload(), 2000)
            } else {
                throw new Error(data.error || 'Неизвестная ошибка');
            }
        } catch (error) {
            console.error('Ошибка отправки данных:', error);
            elements.head?.remove();
            elements.body.style.textAlign = 'center';
            elements.body.style.width = '60%';
            elements.body.innerHTML = `Произошла ошибка при отправке данных: ${error.message}`;
            setTimeout(() => location.reload(), 4000)
        }
    });
});